var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('unicon',{attrs:{"name":"file-alt","fill":"currentColor"}})}
var staticRenderFns = []

export { render, staticRenderFns }